import { isCaseInsensitiveEqual } from '@prophecy/utils/string';

import { ProcessKind } from '../graph/types';

export enum Entity {
  User = 'User',
  Project = 'Project',
  Package = 'Package',
  Pipeline = 'Pipeline',
  StoredProcedure = 'StoredProcedure',
  SqlOrchestratorPipeline = 'SQLOrchestratorPipeline',
  PipelineConfiguration = 'PipelineConfigurations',
  Configuration = 'Configuration',
  Subgraph = ProcessKind.Subgraph,
  Job = 'Job',
  SQL = 'Sql',
  Gem = 'Gem',
  Fabric = 'Fabric',
  UDF = 'UDF',
  Dataset = 'Dataset',
  Schema = 'Schema',
  Team = 'Team',
  Lineage = 'Lineage',
  Template = 'Template',
  Expectation = 'Expectation',
  Observation = 'Observation',
  Member = 'Member',
  writeAndReadPipelines = 'writeAndReadPipelines',
  writeAndReadJobs = 'writeAndReadJobs',
  readDatasets = 'readDatasets',
  writeDatasets = 'writeDatasets',
  SQLBusinessApp = 'SQLBusinessApp',
  Repository = 'Repository',
  Model = 'Model',
  Spatial = 'Spatial',
  Prepare = 'Prepare',
  Transform = 'Transform',
  JoinSplit = 'JoinSplit',
  Custom = 'Custom',
  Parse = 'Parse',
  Snapshot = 'Snapshot',
  Macro = 'Macro',
  Seed = 'Seed',
  Function = 'Function',
  Source = 'Source',
  Transpiler = 'Transpiler',
  UnreferencedSource = 'UnreferencedSource',
  UnreferencedTable = 'UnreferencedTable',
  ExternalSource = 'ExternalSource',
  Table = 'Table',
  View = 'View',
  Connector = 'Connector',
  JobSubgraph = 'JobSubgraph',
  Test = 'Test',
  SingularDataTest = 'SingularDataTest',
  GenericDataTest = 'GenericDataTest',
  MarkdownDocument = 'MarkdownDocument',
  App = 'App',
  Schedule = 'Schedule',
  ERD = 'DesignDataModel',
  Replay = 'Replay',
  File = 'File',
  Attachment = 'Attachment'
}

export const getAppEntityName = (name: Entity) => (isCaseInsensitiveEqual(name, Entity.App) ? 'Analysis' : name);

export type IDEEntity =
  | Entity.Configuration
  | Entity.Pipeline
  | Entity.Job
  | Entity.SQL
  | Entity.Lineage
  | Entity.Observation
  | Entity.Gem
  | Entity.Project;

export type EntityWitUrl =
  | Entity.Dataset
  | Entity.Model
  | Entity.Pipeline
  | Entity.Configuration
  | Entity.Job
  | Entity.SQL
  | Entity.Lineage
  | Entity.Observation
  | Entity.Subgraph
  | Entity.Project
  | Entity.Gem;

export type EntityToCreate = Entity.Pipeline | Entity.Job | Entity.Gem | undefined;
export function getSqlChildEntity(entity: Entity) {
  if (entity === Entity.App) {
    return `sqlBusiness${entity}`;
  }
  return `sql${entity}`;
}

export function getSqlMetadataEntity(entity: Entity) {
  if (entity === Entity.App) {
    return `SQLBusinessApp`;
  }
  return `SQL${entity}`;
}

export function sqlMetadataEntityToEntity(entity: string) {
  if (entity.startsWith('SQLOrchestratorPipeline')) {
    return Entity.SqlOrchestratorPipeline;
  } else if (entity.startsWith('SQLStoredProcedure')) {
    return Entity.StoredProcedure;
  } else if (entity.startsWith('SQLBusinessApp')) {
    return Entity.App;
  }
  if (entity.startsWith('SQLBusinessApp')) {
    return Entity.App;
  }
  return entity.replace(/^SQL/, '') as Entity;
}
